
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkWorkflowActionsStandardtaskEnum } from '../models/work-workflow-actions-standardtask-enum';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateWorkflowStandardtaskDtoFormGroup() {
return new FormGroup({
    standardtaskId: new FormControl<number | undefined>(undefined, [Validators.required]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    action: new FormControl<WorkWorkflowActionsStandardtaskEnum | undefined>(undefined, [Validators.required]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      